import { useFormContext } from 'react-hook-form';

import type { PickTicketsFormSchema } from '../schemas';

export const usePickTicketsFormContext = () => {
  const context = useFormContext<PickTicketsFormSchema>();

  return context;
};
